import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateCheckboxComponent } from "../../templates/template-checkbox/template-checkbox.component";

@Component({
  selector: "app-prefix-jan",
  imports: [TemplateCheckboxComponent],
  templateUrl: "./prefix-jan.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-jan.component.less",
})
export class PrefixJanComponent extends PrefixComponent<boolean> {
  public constructor() {
    super();
    this.characters = ALLOWED_CHARACTERS["jan"];
  }
}
